import request from '@/utils/request'
let apiName = 'bookSub'

export function info(id){
  return request({
    url: `/api/app/${apiName}/${id}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/book-sub.js